import { useEffect } from "react";
import { Helmet } from "react-helmet-async";

const SITE = "https://vornafightwear.com";
const DEFAULT_TITLE = "VORNA — Fightwear Ecuatoriano | MMA, Muay Thai y Grappling";
const DEFAULT_DESC =
  "Marca ecuatoriana de fightwear: pantalonetas de MMA y Muay Thai, rash guards y conjuntos de entrenamiento. Nacido en Ecuador, hecho para la pelea.";

export function Seo({ title, description, path = "", image }) {
  const url = `${SITE}${path}`;
  const t = title && title.trim() ? title : DEFAULT_TITLE;
  const d = description && description.trim() ? description : DEFAULT_DESC;
  const img = image
    ? image.startsWith("http")
      ? image
      : `${SITE}${image}`
    : `${SITE}/og-image.jpg`;

  useEffect(() => {
    // Remove static (non-helmet) duplicates so exactly one tag of each kind remains.
    // Helmet tags are marked with data-seo="true"; react-helmet-async v3 does not emit data-rh.
    document
      .querySelectorAll(
        'link[rel="canonical"]:not([data-seo]), meta[name="description"]:not([data-seo]), meta[property="og:url"]:not([data-seo]), meta[property="og:image"]:not([data-seo]), meta[name="twitter:image"]:not([data-seo])',
      )
      .forEach((el) => el.remove());
  }, []);

  return (
    <Helmet>
      <title>{t}</title>
      <meta name="description" content={d} data-seo="true" />
      <link rel="canonical" href={url} data-seo="true" />
      <meta property="og:title" content={t} data-seo="true" />
      <meta property="og:description" content={d} data-seo="true" />
      <meta property="og:url" content={url} data-seo="true" />
      <meta property="og:image" content={img} data-seo="true" />
      <meta name="twitter:title" content={t} data-seo="true" />
      <meta name="twitter:description" content={d} data-seo="true" />
      <meta name="twitter:image" content={img} data-seo="true" />
    </Helmet>
  );
}
